import { render, staticRenderFns } from "./SearchApp.vue?vue&type=template&id=35c8c7b7&scoped=true&"
import script from "./SearchApp.vue?vue&type=script&lang=js&"
export * from "./SearchApp.vue?vue&type=script&lang=js&"
import style0 from "./SearchApp.vue?vue&type=style&index=0&id=35c8c7b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c8c7b7",
  null
  
)

export default component.exports